module.exports = __webpack_public_path__ + "img/logo-manaus.7dc36d05.png";